import FhirActions from '@enlyt/stores/Fhir/Actions'
import FhirEnhancedActions from 'stores/FhirEnhanced/Actions'
import initGlanceItem from './initGlanceItem'

import iconMedication from 'assets/media/icons/eh-icon-medications.svg'
import iconMedicationGray from '@images/custom/icons/eh-icon-medications-gray.svg'

import iconTest from 'assets/media/icons/eh-icon-test-results.svg'
import iconTestGray from '@images/custom/icons/eh-icon-test-results-gray.svg'

import Medications from './Medications'
import TestResults from './TestResults'

import {
  medicationRequestSearchLoading,
  medicationRequestSearchError,
  medicationRequest
} from '@enlyt/stores/Fhir/Select'

import {
  observationSearchHomeLoading as observationSearchLoading,
  observationSearchHomeError as observationSearchError,
  observationHome as observation
} from 'stores/FhirEnhanced/Select'

const MEDICATIONS = 'medications'
const TEST_RESULTS = 'testResults'

const MEDICATIONS_LINK = '/myHealth?id=medications'
const TEST_RESULTS_LINK = '/myHealth'

const items = [
  {
    name: MEDICATIONS,
    icon: iconMedication,
    iconGray: iconMedicationGray,
    linkTo: MEDICATIONS_LINK,
    content: Medications,
    selectors: {
      loading: medicationRequestSearchLoading,
      json: medicationRequest,
      error: medicationRequestSearchError
    },
    request: FhirActions.medicationRequestSearch,
    isAllowedToAdolescent: false
  },
  {
    name: TEST_RESULTS,
    icon: iconTest,
    iconGray: iconTestGray,
    linkTo: TEST_RESULTS_LINK,
    content: TestResults,
    selectors: {
      loading: observationSearchLoading,
      json: observation,
      error: observationSearchError
    },
    request: FhirEnhancedActions.observationSearchHomeEnhanced,
    queryFHIR: '_count=50',
    isAllowedToAdolescent: false
  }
]

export default items.map(item => ({
  ...item,
  Component: initGlanceItem(item)
}))
